





























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";

@Component({
  filters: {
    truncate(v: string, n: number) {
      if (!v) return v;
      return v.length > n ? v.slice(0, n) + "…" : v;
    }
  }
})
export default class KasusRtlStep extends Vue {
  @Prop({ default: null }) session!: any;
  dialog = false;
  cur: any = {};
  saving = false;
  autoLoading = false;
  error = "";

  statusOpts = [
    { text: "Open", value: "open" },
    { text: "In Progress", value: "in_progress" },
    { text: "Closed", value: "closed" },
    { text: "Overdue", value: "overdue" }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  get canPopulate() {
    return !!(this.session && this.session.id);
  }

  get rtls() {
    if (!this.session || !this.session.observations) return [];
    return this.session.observations
      .filter((o: any) => o.kasus_rtl)
      .map((o: any) => ({ ...o.kasus_rtl, observation: o }));
  }

  statusColor(s: string) {
    if (s === "closed") return "success";
    if (s === "in_progress") return "primary";
    if (s === "overdue") return "error";
    return "warning";
  }

  async autoFill() {
    if (!this.canPopulate) return;
    this.autoLoading = true;
    try {
      await this.store.autoPopulateRtl(this.session.id);
    } catch (e) {
      alert(e.response?.data?.message || "Gagal auto-populate RTL");
    } finally {
      this.autoLoading = false;
    }
  }

  edit(rtl: any) {
    this.cur = { ...rtl };
    this.error = "";
    this.dialog = true;
  }

  async save() {
    this.error = "";
    this.saving = true;
    try {
      await this.store.updateRtl({
        id: this.session.id,
        rtlId: this.cur.id,
        data: this.cur
      });
      this.dialog = false;
    } catch (e) {
      this.error =
        e.response?.data?.message || e.message || "Gagal menyimpan RTL";
    } finally {
      this.saving = false;
    }
  }
}
